import { Fragment } from 'react';
import { graphql, useStaticQuery } from 'gatsby';

import './styles/products.scss';
import Slider from '../sliders/slider';
import SchedulerScreenshot from './partials/app-screenshot';
import BackgroundCurveSVG from './partials/background-curve';
import BackgroundCurveCoverSVG from './partials/background-curve-cover';
import BackgroundItemsSVG from './partials/background-items';

const Products = ({ modalTitle, ...props }) => {
  const data = useStaticQuery(graphql`
    {
      allWordpressPage(filter: { slug: { eq: "signup" } }) {
        edges {
          node {
            acf {
              sign_up {
                signup_modal_submit
              }
            }
          }
        }
      }
    }
  `);
  
  const pageContent = data.allWordpressPage.edges[0].node.acf;

  return (
    <section
      className={ `${
        !props.hasHeadline ? 'svg-container' : ''
      } section products-section has-text-centered` }
      data-section="products component"
    >
      {props.hasHeadline && (
        <Fragment>
          <h2 className="sub-title">{props.header.sub_title}</h2>
          <h3 className="headline">{props.header.title}</h3>
        </Fragment>
      )}
      <Slider
        { ...props }
        hasCta
        hasHeader
        hasTitle
        hasCopy
        hasImage
        signupModalSubmit={ pageContent.sign_up.signup_modal_submit }
        modalTitle={ modalTitle }
      />
      {!props.hasHeadline && (
        <Fragment>
          <SchedulerScreenshot { ...props } />
          <BackgroundItemsSVG />
          <BackgroundCurveSVG />
          <BackgroundCurveCoverSVG />
        </Fragment>
      )}
    </section>
  );
};

export default Products;
